export default "__VITE_ASSET__Crr5nSgb__"